import React from "react";

const ChatKG2Icon: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 160 160"
      className={className}
      width="1em"
      height="1em"
    >
      <path
        d="M16.83,146.17c-1.62-.02-2.91-1.33-2.92-2.95-.26-27.94-.16-55.25-.07-70.03.05-8.33,2.23-16.49,6.34-23.73C30.69,30.96,49.85,12.44,85.29,13.8c35.74,1.38,59.96,18.4,62.88,54.91,1.06,13.24.63,31.1-2.89,40.52-5.7,15.28-18.68,37.04-56.46,36.53-16.93-.23-46.78.69-71.99.41Z"
        fill="white"
        stroke="currentColor"
        strokeWidth="11"
        strokeMiterlimit="10"
      />
      <polyline
        points="73.87 57.64 110.32 95.52 47.99 107.95 71.71 61.96"
        fill="white"
        stroke="currentColor"
        strokeWidth="9"
        strokeMiterlimit="10"
      />
      <circle
        cx="72.71"
        cy="55.26"
        r="9.29"
        fill="white"
        stroke="currentColor"
        strokeWidth="9"
        strokeLinecap="round"
        strokeMiterlimit="10"
      />
      <circle
        cx="47.99"
        cy="106.67"
        r="9.13"
        fill="white"
        stroke="currentColor"
        strokeWidth="9"
        strokeLinecap="round"
        strokeMiterlimit="10"
      />
      <circle
        cx="110.32"
        cy="95.29"
        r="9.29"
        fill="white"
        stroke="currentColor"
        strokeWidth="9"
        strokeLinecap="round"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export default ChatKG2Icon;
